import {AbstractFilterComponent} from "./abstract-filter-component.js";
import {FilterLabel} from "./components/label.js";

export class FilterFulltextSearch extends AbstractFilterComponent {

	static selector = '.js-filter-fulltext-search';
	static formSelector = '.js-search-box';
	static formFieldSelector = '.js-filter-fulltext-search--field';

	constructor(parent, filter, node) {
		super(parent, filter, node);

		this.nodeForm = document.querySelector(FilterFulltextSearch.formSelector);
		this.nodeFormField = document.querySelector(FilterFulltextSearch.formFieldSelector);
	}

	inactivateSearch() {
		let self = this;

		window.Search.toggleClasses(self.nodeForm);
		window.Search.destroyBaseTemplate(self.nodeForm);
	}

	getFormData() {
		let self = this;
		let data = {};

		if (self.node.value) {
			data[self.node.name] = self.node.value;
		}

		return data;
	}

	getLabel() {
		let self = this;

		if (! self.node.value) {
			return;
		}

		if (self.label) {
			return self.label;
		}

		self.label = new FilterLabel(self, self.node.dataset.labelPattern.replace('{content}', self.node.value));
		return self.label;
	}

	labelDismissed() {
		let self = this;
		self.filter.setForceUpdateMode();

		self.label = null;
		self.node.value = null;
		self.nodeFormField.value = '';

		self.componentStateChanged();
	}
}
